import type { ApiResponse } from "@/models/api";
import { ApiClient } from "@/utils/apiClient";
import type { ApiPaginationPayload } from "@/models/api";
import type { Category } from "@/models/category";

export type CategoryListPayload = {}

export type CategoryListGetResponse = ApiResponse<Category[]>;

export abstract class CategoryApiService {
  public static async get(): Promise<CategoryListGetResponse> {
    const response = await ApiClient.getClient().get<CategoryListGetResponse>('/categories')
    return response.data;
  }
}